import { FC, useMemo, useState } from 'react';
import {
    CalendarBackgroundModal,
    CalendarModalWrapper,
} from '../Calendar/styles';

import { CalendarWithWavesContainer, CustomDropdown } from './styles';

import { addDaysToDate } from '../../helpers/utils';
import { useGetShopItemsServices } from '../../hooks/useGetShopItemsServices';
import {
    CartServiceType,
    CartValuesServiceStore,
    useShoppingCartStore,
} from '../../store/shoppingCart/shoppingCartStore';
import { BigButton } from '../BigButton';
import { CalendarProps } from '../Calendar';
import { CustomReactCalendar } from '../Calendar/CustomReactCalendar';
import { Dropdown } from '../Dropdown';
import { PseudoCalendar } from '../PseudoCalendar';
import animations from '../../helpers/animations';

interface CalendarWithServicesProps extends Omit<CalendarProps, 'onClose'> {
    onClose?: (d: CartValuesServiceStore | null) => void;
    defaultData: CartValuesServiceStore;
}

export const CalendarWithServices: FC<CalendarWithServicesProps> = ({
    onClose,
    defaultData,
}) => {
    const { cartValues } = useShoppingCartStore();
    const [value, setValue] = useState<Date>(defaultData.date);
    const [currentService, setCurrentService] = useState<string>(
        defaultData.title
    );

    const modifyValueInDays = (days: number) => () => {
        setValue(oldValue => {
            const newValue = addDaysToDate(oldValue, days);
            return newValue;
        });
    };

    const { data: dataServices } = useGetShopItemsServices({
        Date: value,
    });

    const servicesWithoutCart = useMemo(() => {
        if (!dataServices?.length) return [];

        const dataServicesElements = dataServices.filter(service => {
            cartValues?.find(cart => cart.id === String(service.id));

            return !!cartValues;
        });

        return dataServicesElements;
    }, [cartValues, dataServices]);

    const findCurrentServiceSelected = useMemo(
        () =>
            servicesWithoutCart.find(
                item => item.exhibitionName === currentService
            ),
        [currentService, servicesWithoutCart]
    );

    const generalData: CartValuesServiceStore = {
        id: String(findCurrentServiceSelected?.id || defaultData.id),
        date: value,
        type: CartServiceType.Services,
        value: findCurrentServiceSelected?.value || defaultData.value,
        title: findCurrentServiceSelected?.exhibitionName || defaultData.title,
    };

    return (
        <CalendarBackgroundModal
            onClick={e => {
                e.stopPropagation();
                onClose && onClose(null);
            }}
            {...animations.calendar}
        >
            <CalendarModalWrapper
                onClick={e => {
                    e.stopPropagation();
                }}
            >
                <CalendarWithWavesContainer>
                    <h2 className="title">Calendário</h2>

                    <div className="category-wrapper">
                        <CustomDropdown>
                            <Dropdown
                                elements={servicesWithoutCart.map(item => ({
                                    id: String(item.id),
                                    value: item.exhibitionName,
                                }))}
                                title="Selecione um serviço"
                                setCurrentSelected={setCurrentService}
                                currentSelected={currentService}
                                allSize
                            />
                        </CustomDropdown>
                    </div>
                    <PseudoCalendar
                        onNext={modifyValueInDays(1)}
                        onPrevious={modifyValueInDays(-1)}
                        date={value!}
                    />
                    <CustomReactCalendar setValue={setValue} value={value} />
                    <div className="line-divider"></div>
                    <div className="buttons-wrapper">
                        <BigButton
                            color="secondary-alt"
                            bgColor="secondary"
                            children={'Cancelar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(null);
                            }}
                        />
                        <BigButton
                            color="primary"
                            bgColor="primary"
                            children={'Salvar'}
                            onClick={e => {
                                e.stopPropagation();
                                if (onClose) onClose(generalData);
                            }}
                        />
                    </div>
                </CalendarWithWavesContainer>
            </CalendarModalWrapper>
        </CalendarBackgroundModal>
    );
};
